import React from 'react';
import { undoDateFormat, textfieldDateFormat } from "../../../utils/dateFunctions";
import { numberFormat } from "../../../utils/numberFunctions";
import { handlePagination, postApi } from "../../../utils/apiFunction";
import MUIDataTable from "mui-datatables";
import { getOysterGrades, gradeSort } from "../../../definitions/oysters";
import Link from "@mui/material/Link";
import IconButton from "@mui/material/IconButton";
import WebhookIcon from '@mui/icons-material/Webhook';
import { useJumboTheme } from "@jumbo/hooks";
import { Box, CircularProgress, Typography } from "@mui/material";
import { TableCell, TableRow, TableFooter } from "@mui/material";
import { ThemeProvider } from '@mui/material/styles';
import { tableTheme } from '../../../themes/tableTheme';
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { adalApiFetch } from '../../../../adalConfig';
import DataTableStandard from "../../../components/DataTableStandard";
import { reverseSort } from '../../../utils/sortFunctions';
import { salesOrderAndShipmentsTypes, statusList } from '../../../utils/constants/selectFields';
import getBillData from '../Function/GetBillData';
import { DatePickerAutoOpen } from '../../../shared/DatePicker';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import { SOstatusList } from '../../../utils/constants/selectFields';
import { SimpleStringSelect } from "../../../components/StringSelect";
import FormModal from '../../../components/FormModal';
import { checkAccess } from '../../../utils/roleFunctions';
import BillLines from './BillLines';
import PDFViewer from '../../../components/PDFViewer';
import Swal from 'sweetalert2';
import DeleteIcon from '@mui/icons-material/Delete';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import dayjs from 'dayjs';


const getEmlUri = (pdfUri) => {
    if (!pdfUri || typeof pdfUri !== 'string') {
        return '';
    }

    const emlUri = pdfUri.replace(/\.pdf(?=([?#]|$))/i, '.eml');

    return emlUri !== pdfUri ? emlUri : '';
};

const BillsEditable = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [loading, setLoading] = React.useState(false);
    const [columns, setColumns] = React.useState([]);
    const [procurement, setProcurement] = React.useState([]);
    const [colourOverride, setColourOverride] = React.useState([]);
    const [localReload, setLocalReload] = React.useState(false);
    const [tableReload, setTableReload] = React.useState(false);
    const [editorRows, setEditorRows] = React.useState(new Set()); // track inline editor rows
    const { theme } = useJumboTheme();
    /*const allowEdit = checkAccess(props.access, { key: ACCESS_SECTIONS.AP, value: ACCESS.EDIT });*/
    const allowApprove = checkAccess(props.access, { key: ACCESS_SECTIONS.AP, value: ACCESS.ADMIN });
    const canEditWorkflow3 = checkAccess(props.access, { key: ACCESS_SECTIONS.AP, value: ACCESS.ADMIN });
    const isWorkflow4 = String(props.workflowId ?? '') === '4';
    const showExcludeAction = props.showExcludeAction ?? ['1', '2'].includes(String(props.workflowId ?? ''));

    const toggleEditorRowByIndex = React.useCallback((dataIndex) => {
        const rowObj = procurement[dataIndex];
        const key = rowObj?.id ?? dataIndex;
        setEditorRows(prev => {
            const next = new Set(prev);
            if (next.has(key)) next.delete(key); else next.add(key);
            return next;
        });
    }, [procurement]);

    const triggerReload = React.useCallback(() => {
        setLocalReload(r => !r);
    }, []);


    const triggerTableReload = React.useCallback(() => {
        setTableReload(r => !r);
    }, []);

    const handleDeleteOrder = React.useCallback((dataIndex) => {
        const supplier = procurement[dataIndex]?.supplierName || '';

        Swal.fire({
            icon: 'warning',
            title: `Are you sure you want to DELETE ${supplier}?`,
            showCancelButton: true,
            confirmButtonText: 'Yes, Continue',
            cancelButtonText: 'No',

        }).then(async result => {
            if (result.value) {
                setLoading(true);
                const key = procurement[dataIndex]?.id;
                console.log("Deleting", key);

                var promArr = [];
                promArr.push(await adalApiFetch(fetch, uri + '/APBills/Delete/' + key, {
                    method: 'post',
                }))

                await Promise.all(promArr);

                setLoading(false);
                setTableReload(r => !r);
            } else if (result.dismiss === Swal.DismissReason.cancel) { }
        });
    }, [procurement, uri]);

    const handleAIRetraining = React.useCallback((dataIndex) => {
        const supplier = procurement[dataIndex]?.supplierName || '';

        Swal.fire({
            icon: 'warning',
            title: `Send ${supplier} to AI retraining?`,
            text: 'The bill will still appear in the lists and be marked for model retraining.',
            showCancelButton: true,
            confirmButtonText: 'Yes, retrain it',
            cancelButtonText: 'No',

        }).then(async result => {
            if (result.value) {
                setLoading(true);
                const key = procurement[dataIndex]?.id;

                try {
                    await adalApiFetch(fetch, uri + '/APBills/AIRetraining/' + key, {
                        method: 'post',
                    });

                    await Swal.fire('Marked', 'Bill marked for retraining.', 'success');
                    setTableReload(r => !r);
                } finally {
                    setLoading(false);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) { }
        });
    }, [procurement, uri]);

    const handleAIRetrainingAndDelete = React.useCallback((dataIndex) => {
        const supplier = procurement[dataIndex]?.supplierName || '';

        Swal.fire({
            icon: 'warning',
            title: `Send ${supplier} to AI retraining and delete it?`,
            text: 'This will keep the bill for retraining and remove it',
            showCancelButton: true,
            confirmButtonText: 'Yes, retrain and delete',
            cancelButtonText: 'No',

        }).then(async result => {
            if (result.value) {
                setLoading(true);
                const key = procurement[dataIndex]?.id;

                try {
                    await adalApiFetch(fetch, uri + '/APBills/AIRetrainingHide/' + key, {
                        method: 'post',
                    });

                    await Swal.fire('Hidden', 'Bill kept for retraining.', 'success');
                    setTableReload(r => !r);
                } finally {
                    setLoading(false);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) { }
        });
    }, [procurement, uri]);



    // Add: helper to change status then refresh
    const handleChangeStatus = React.useCallback(async (id, newStatus) => {
        if (!id) return;
        await postApi('/CreditMemo/UpdateField/' + id, { Status: newStatus });
        triggerTableReload();
    }, [triggerTableReload]);

    React.useEffect(() => {
        var cols = [
            {
                name: 'id',
                label: 'Id'
            },
            {
                name: 'status',
                label: 'Status',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        var proc = procurement;
                        var status = proc[dataIndex]?.status?.trim?.() ?? proc[dataIndex]?.status;
                        return <span>{status}</span>;
                    },
                    sortCompare: reverseSort
                }
            },
            ...(isWorkflow4 ? [{
                name: 'billMyobId',
                label: 'MYOBid',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        var tenant = process.env.REACT_APP_MYOB_TENANT ? process.env.REACT_APP_MYOB_TENANT : 'https://aoc.myobadvanced.com/Main?';
                        var linkedBillMyobId = procurement[dataIndex]?.billMyobId;

                        if (!linkedBillMyobId) {
                            return <span></span>;
                        }

                        return <Link href={tenant + 'ScreenId=AP301000&Type=Bill&RefNbr=' + linkedBillMyobId} target='_blank'>{linkedBillMyobId}</Link>;
                    },
                    sortCompare: reverseSort
                }
            }] : []),
            {
                name: 'supplierName',
                label: 'Supplier Name'
            },
            {
                name: 'abn',
                label: 'ABN'
            },
            {
                name: 'supplierRef',
                label: 'Supplier Ref'
            },
            {
                name: 'description',
                label: 'Description'
            },
            {
                name: 'date',
                label: 'Date',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        return <span>{dayjs(procurement[dataIndex]?.date).format('DD/MM/YYYY')}</span>;
                    }
                }
            },
            {
                name: 'dueDate',
                label: 'Due Date',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        return <span>{dayjs(procurement[dataIndex]?.dueDate).format('DD/MM/YYYY')}</span>;
                    }
                }
            },
            {
                name: 'amount',
                label: 'Amount'
            },
            ...(isWorkflow4 ? [{
                name: 'emlDownload',
                label: 'EML',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        const emlUri = getEmlUri(procurement[dataIndex]?.uri);

                        if (!emlUri) {
                            return <span></span>;
                        }

                        return (
                            <IconButton
                                component="a"
                                href={emlUri}
                                download
                                size="small"
                                title="Download EML"
                                aria-label="Download EML"
                                onClick={(event) => event.stopPropagation()}
                            >
                                <EmailOutlinedIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        );
                    },
                    filter: false,
                    sort: false,
                }
            }] : []),
            {
                name: 'delete',
                label: 'Delete',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        const isApproved = procurement[dataIndex]?.status === 'Approved';
                        return (
                            <IconButton
                                aria-label="delete"
                                onClick={(e) => { e.stopPropagation(); handleDeleteOrder(dataIndex); }}
                                title={isApproved ? 'Cannot delete an approved bill' : 'Delete'}
                                disabled={isApproved}>
                                <DeleteIcon sx={{ fontSize: 18 }} />
                            </IconButton>
                        );
                    },
                }
            },
            ...(showExcludeAction ? [{
                name: 'aiRetraining',
                label: 'Retrain',
                options: {
                    customBodyRenderLite: (dataIndex) => {
                        const isApproved = procurement[dataIndex]?.status === 'Approved';

                        return (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                <IconButton
                                    aria-label="send bill to AI retraining"
                                    onClick={(e) => { e.stopPropagation(); handleAIRetraining(dataIndex); }}
                                    title="Retrain">
                                    <FindInPageIcon sx={{ fontSize: 18 }} />
                                </IconButton>

                                <IconButton
                                    aria-label="send bill to AI retraining and delete it"
                                    onClick={(e) => { e.stopPropagation(); handleAIRetrainingAndDelete(dataIndex); }}
                                    title={isApproved ? 'Cannot delete an approved bill' : 'Retrain and Delete'}
                                    disabled={isApproved}>
                                    <DeleteSweepIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </Box>
                        );
                    },
                }
            }] : [])
        ]

        setColumns(cols);
    }, [handleDeleteOrder, handleAIRetraining, handleAIRetrainingAndDelete, isWorkflow4, props.customerFilter, procurement, showExcludeAction, toggleEditorRowByIndex])

    const changeStatus = (index) => (newStatus) => {
        var statusOR = colourOverride.findIndex((col) => { return col.index === index });
        if (statusOR >= 0) {
            var newCol = [...colourOverride];
            newCol[statusOR].status = newStatus;
            setColourOverride(newCol);
        } else {
            setColourOverride([...colourOverride, { index: index, status: newStatus }]);
        }
    }

    const nextStatus = (currentStatus) => {
        if (currentStatus === "Select Stock") return "Awaiting Approval";
        if (currentStatus === "Awaiting Approval") return "Confirmed";
        return currentStatus;
    }

    const nextStatusLabel = (currentStatus) => {
        if (currentStatus === "Select Stock") return "Submit for Approval";
        if (currentStatus === "Awaiting Approval") return "Confirm Receival";
        return currentStatus;
    }

    const options = {
        filterType: 'dropdown',
        selectableRowsHideCheckboxes: true,
        fixedHeader: true,
        rowsPerPage: 15,
        responsive: 'standard',
        onRowClick: props.onClick ? props.onClick(procurement) : (() => { }),
        customRowRender: (data, dataIndex, rowIndex) => {
            var rowStyle = {
                background: getColour(data[5]),
            };
            var cellStyle = {
                fontSize: '12px',
                paddingTop: '3px',
                paddingBottom: '3px',
                whiteSpace: 'nowrap',
                maxWidth: '150px',
                overflow: 'hidden'

            };

            const rowObj = procurement[dataIndex];
            const rowKey = rowObj?.id ?? dataIndex;
            const isEditing = editorRows.has(rowKey);

            return (
                <React.Fragment key={rowKey}>
                    <TableRow
                        style={{ ...rowStyle, cursor: 'pointer' }}
                        onClick={() => toggleEditorRowByIndex(dataIndex)}
                    >
                        {columns.map((coll, i) => {
                            if (coll.name === 'delete' || coll.name === 'aiRetraining' || coll.name === 'status' || coll.name === 'dueDate' || coll.name === 'date' || coll.name === 'billMyobId' || coll.name === 'emlDownload') {
                                return <TableCell key={coll.name} style={cellStyle}>{data[i](dataIndex)}</TableCell>
                            }
                            else if (coll.name === 'description' && (data[5] === ('Select Stock') || data[5] === ('Awaiting Approval'))) {
                                return <TextTableCell key={coll.name} style={cellStyle} text={data[i]} id={rowObj?.id} onCommit={triggerReload} />
                            }
                            else if (coll.name === 'isReused' && (data[5] === ('Select Stock') || data[5] === ('Awaiting Approval'))) {
                                return <CheckBoxTableCell key={coll.name} style={cellStyle} checked={data[i] === 'Yes'} id={rowObj?.id} onCommit={triggerReload} />
                            }
                            else {
                                return <TableCell key={coll.name} style={cellStyle}>{data[i]}</TableCell>
                            }
                        })}
                    </TableRow>

                    {isEditing && (
                        <TableRow>
                            <TableCell colSpan={columns.length} style={{ background: theme.palette.background.default, padding: 12 }}>

                                <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                                    <Box
                                        sx={{
                                            flex: '1 1 420px',
                                            minWidth: 0,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            borderRadius: 1,
                                            overflow: 'hidden',
                                            bgcolor: 'background.paper'
                                        }}
                                    >
                                        {rowObj?.uri ? (
                                            <PDFViewer URI={rowObj.uri} height="72vh" />
                                        ) : (
                                            <Box sx={{ p: 2 }}>
                                                <Typography variant="body2">No PDF is available for this bill.</Typography>
                                            </Box>
                                        )}
                                    </Box>

                                    <Box sx={{ flex: '1.35 1 560px', minWidth: 0 }}>
                                        <BillLines
                                            data={rowObj}
                                            onSaved={triggerTableReload}
                                            workflowId={props.workflowId}
                                            canEditWorkflow3={canEditWorkflow3}
                                        />
                                    </Box>
                                </Box>


                                <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap' }}>
                                    {/* New: Change Status button beside Close */}
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            setEditorRows(prev => { const n = new Set(prev); n.delete(rowKey); return n; });
                                        }}
                                    >
                                        Close
                                    </Button>
                                </div>
                            </TableCell>
                        </TableRow>
                    )}
                </React.Fragment>
            );
        }
    };

    const getColour = (selRow) => {
        if (selRow === ("Completed")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Select Stock")) {
            return theme.palette.oysterProducts.onhold
        } else if (selRow === ("Approved")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Pending Approval")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Open")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Balanced")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Invoiced")) {
            return theme.palette.oysterProducts.completed
        } else if (selRow === ("Awaiting Approval")) {
            return 'rgba(152, 251, 152,0.3)'
        } else if (selRow === ("Canceled")) {
            return theme.palette.oysterProducts.cancelled
        } else if (selRow === ("Invoice Paid Error")) {
            return 'rgba(255, 0, 0, 0.5)'
        }
    }

    React.useEffect(() => {
        const abortController = new AbortController();
        setProcurement([]);
        setColourOverride([]);
        getBillData(
            props.workflowId,
            props.userName,
            props.startDate,
            props.endDate,
            Boolean(props.enableDateFilter),
            {
                includeAIRetraining: Boolean(props.includeAIRetraining),
                aiRetrainingOnly: Boolean(props.aiRetrainingOnly),
            },
            abortController,
            setLoading,
            setProcurement
        );
        return () => {
            abortController.abort();
        };
    }, [props.workflowId, props.userName, props.startDate, props.endDate, props.enableDateFilter, props.includeAIRetraining, props.aiRetrainingOnly, props.reload, tableReload]);


    return (
        <DataTableStandard
            data={props.filter ? props.filter(procurement) : procurement}
            title={<Typography variant={'h3'}>{props.title ?? 'Bills'}</Typography>}
            columns={columns}
            options={options}
            returnSearch={!loading}
            reload={props.reloadFunc}
            shrink={true}

        />
    );
};

export default BillsEditable;

const TextTableCell = (props) => {
    const [selected, setSelected] = React.useState(false);
    const [text, setText] = React.useState(props.text);

    const updateValue = (newData) => {
        var params = {};
        params['Description'] = newData;
        setText(newData);
        postApi('/CreditMemo/UpdateField/' + props.id, params);

    };

    const finishediting = () => {
        setSelected(false);
        if (typeof props.onCommit === 'function') props.onCommit();
    }

    if (selected) {
        return <TableCell {...props} style={{ maxWidth: '500px' }} > <TextField
            autoFocus
            disabled={props.disabled}
            id="desc"
            value={text ?? ''}
            onChange={(event) => { updateValue(event.target.value) }}
            multiline
            InputLabelProps={{
                shrink: true,
            }}
            rows={4}
            onBlur={() => finishediting()}
        />
        </TableCell>
    } else {
        return <TableCell {...props} onClick={() => { setSelected(true) }} >{text}</TableCell>
    }
}

const CheckBoxTableCell = (props) => {
    const [editing, setEditing] = React.useState(false);
    const [checked, setChecked] = React.useState(Boolean(props.checked));

    const updateValue = (newChecked) => {
        setChecked(newChecked);
        postApi('/CreditMemo/UpdateField/' + props.id, { IsReused: newChecked });
        setEditing(false);
    };

    const finishediting = () => {
        setEditing(false);
        if (typeof props.onCommit === 'function') props.onCommit();
    }

    if (editing) {
        return (
            <TableCell {...props} style={{ maxWidth: '250px' }}>
                <Checkbox
                    autoFocus
                    checked={checked}
                    onChange={(event) => updateValue(event.target.checked)}
                    onBlur={() => finishediting()}
                />
            </TableCell>
        );
    } else {
        return (
            <TableCell {...props} onClick={() => setEditing(true)}>
                <Checkbox checked={checked} disabled />
            </TableCell>
        );
    }
}

const StatusTableCell = (props) => {
    const [selected, setSelected] = React.useState(false);
    const [data, setData] = React.useState(props.data);
    const updateValue = (newData) => {
        var params = {};
        params['Status'] = newData;
        postApi('/SalesOrder/UpdateField/' + props.id, params);
        setData(newData);
        props.changeStatus(newData);
    };

    if (selected) {
        return <TableCell {...props} style={{ maxWidth: '150px' }} >
            <SimpleStringSelect width={150} state={data} setState={updateValue} options={SOstatusList} default={0} autoFocus />
        </TableCell>
    } else {
        return <TableCell {...props} onClick={() => { setSelected(true) }} >{props.data}</TableCell>
    }
}
